export const LOADING = 'AUTH_LOADING';
export const SET_USER_INFO = 'AUTH_SET_USER_INFO';
export const LOGOUT = 'LOGOUT'